import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map, startWith, tap } from 'rxjs/operators';

import { breakpoints } from 'src/styles/breakpoints';

import { NavigationItemIdEnum } from './mobile-bottom-navigation.model';

@Injectable({
  providedIn: 'root'
})
export class MobileBottomNavigationService {
  $isVisible = new BehaviorSubject(false);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
    this.handleVisibilityStatus();
  }

  watchRouteChanges$() {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(this.router),
      map(() => this.route.snapshot),
      map((routeSnapshot) => {
        let currentChildSnapshot = routeSnapshot;
        let mobileBottomNavigationItemId: NavigationItemIdEnum | undefined =
          undefined;

        while (currentChildSnapshot) {
          const { data } = currentChildSnapshot;

          if (data.mobileBottomNavigationItemId) {
            mobileBottomNavigationItemId = data.mobileBottomNavigationItemId;
            break;
          }

          currentChildSnapshot = currentChildSnapshot.firstChild;
        }

        return mobileBottomNavigationItemId;
      })
    );
  }

  handleVisibilityStatus() {
    const mobileBreakpointQuery = `(max-width: ${breakpoints.mobileMd})`;
    const breakpointObserver$ = this.breakpointObserver
      .observe(mobileBreakpointQuery)
      .pipe(map((res) => res.matches));

    combineLatest([breakpointObserver$, this.watchRouteChanges$()])
      .pipe(
        tap(([isMobile, navigationItemId]) => {
          const isBottomNavigationVisibleOnCurrentPage = !!navigationItemId;

          const isBottomNavigationVisible =
            isMobile && isBottomNavigationVisibleOnCurrentPage;

          this.$isVisible.next(isBottomNavigationVisible);
        })
      )
      .subscribe();
  }
}
